var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-container',{staticClass:"app-desktop-header",attrs:{"fluid":"","tag":"header"}},[_c('BfTitle',[_vm._v(_vm._s(_vm.title))]),_c('LogoutLink')],1)}
var staticRenderFns = []

export { render, staticRenderFns }